import { createContext, useContext } from 'react';
export const VoiceModeImplementationContext = createContext(undefined);
export function useVoiceModeImplementation() {
    return useContext(VoiceModeImplementationContext);
}
//# sourceMappingURL=voiceModeImplementationShared.js.map